import { render, staticRenderFns } from "./CardInteligenciaTerritorialPotencialAgropecuarioOutrosImovel.vue?vue&type=template&id=0adab4d1&scoped=true&lang=pug"
import script from "./CardInteligenciaTerritorialPotencialAgropecuarioOutrosImovel.vue?vue&type=script&lang=js"
export * from "./CardInteligenciaTerritorialPotencialAgropecuarioOutrosImovel.vue?vue&type=script&lang=js"
import style0 from "./CardInteligenciaTerritorialPotencialAgropecuarioOutrosImovel.vue?vue&type=style&index=0&id=0adab4d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adab4d1",
  null
  
)

export default component.exports